import { QuotaService } from '@qdrant/qdrant-cloud-public-api/quota/v1';
import { getAccountQuotas, getAuthenticatedUserQuotas } from '@qdrant/qdrant-cloud-public-api/quota/v1/connect-query';
import { transport } from '@/api/transport';
import { createServiceQueries, queryOptions } from '@/connect-query';

export const quotaService = createServiceQueries(QuotaService, {
  getAccountQuotasQuery: (params) => queryOptions(getAccountQuotas, params, { transport }),
  getAuthenticatedUserQuotasQuery: () => queryOptions(getAuthenticatedUserQuotas, {}, { transport }),
});
